import {
  LizanoListInfo,
  LizanoMetaData,
} from '../../sections/ListsSection/lists/lists';
import { validExportReportTypes } from '../constants';

export const isValidExportReportType = (reportType: string | undefined) => {
  return reportType && Object.keys(validExportReportTypes).includes(reportType);
};

export const getListNamesFromIds = (
  listIds: number[],
  lists: LizanoListInfo[]
) => {
  if (!lists) return [];
  return listIds.map((listId) => {
    return lists.find((list) => list.id === listId)?.name || '';
  });
};

export const defaultSelectedReportTypeFilter = (brand: string) => {
  switch (brand) {
    case 'NeighborWho':
      return 'property_report';
    case 'BeenVerified':
      return 'detailed_person_report';
    case 'PeopleSmart':
      return 'contact_report';
    default:
      return 'all';
  }
};

export const isListReportSameAsSelectedReportTypeFilter = (
  listReport: LizanoMetaData,
  selectedReportType: string
) => {
  return (
    listReport.report?.report_type === selectedReportType ||
    selectedReportType === 'all'
  );
};

export const listHasReports = (
  list: LizanoListInfo,
  selectedReportType: string
) => {
  const listReports = list.list_reports.map((lr) => lr);
  const validReports = listReports.filter((lr) => {
    return (
      lr.report?.report_type && isValidExportReportType(lr.report.report_type)
    );
  });
  const filteredReports = validReports.filter((lr) =>
    isListReportSameAsSelectedReportTypeFilter(lr, selectedReportType)
  );
  return Boolean(filteredReports.length);
};
